<template>
  <div>
    <div class="">
      <ul v-if="parts?.length" class="parts-list">
        <li v-for="(part, index) in parts" :key="index">
          <strong>{{ part.quantity }} x {{ part.description }} </strong>
          <span>{{ $t("orders.parts.weight") }}: {{ part?.weight || 0 | formatUnit("kg") }}</span>
          <span class="desc">({{ part.carrier }})</span>
          <md-button class="md-icon-button md-dense btn-flat md-accent" @click="removePart(index)">
            <md-icon>delete</md-icon>
          </md-button>
        </li>
      </ul>
    </div>
    <md-button class="md-secondary" @click="showAddPartModal">{{ $t("orders.parts.addPart") }}</md-button>

    <modal v-if="addPartModal" @close="hideAddPartModal">
      <template slot="header">
        <h4 class="modal-title">{{ $t("orders.parts.addPart") }}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideAddPartModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <ValidationObserver v-slot="{}" ref="addPartForm">
          <ValidationProvider name="quantity" rules="required|numeric|min_value:1" v-slot="{ errors }">
            <md-field>
              <label>{{ $t("orders.parts.quantity") }}</label>
              <md-input v-model="newPart.quantity" type="number"></md-input>
              <div class="md-error" v-if="errors[0]">{{ errors[0] }}</div>
            </md-field>
          </ValidationProvider>

          <ValidationProvider name="description" :rules="{ required: true, regex: /^[^,]*$/ }" v-slot="{ errors }">
            <md-field>
              <label>{{ $t("orders.parts.description") }}</label>
              <md-input v-model="newPart.description" type="text"></md-input>
              <div class="md-error" v-if="errors[0]">{{ errors[0] }}</div>
            </md-field>
          </ValidationProvider>

          <ValidationProvider name="newPart.weight" :rules="{ min_value: 0.1, decimal: 1 }" v-slot="{ passed, failed, errors }">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>{{ $t("orders.parts.weight") }}</label>
              <md-input v-model="newPart.weight" type="number" min="0.1" step="0.1" inputmode="decimal"> </md-input>
              <span class="md-suffix">kg</span>
              <div class="md-error" v-if="errors[0]">
                {{ $t(errors[0]) }}
              </div>
            </md-field>
          </ValidationProvider>

          <ValidationProvider name="carrier" rules="required" v-slot="{ errors }">
            <md-field>
              <div class="wrap-v-select custom-wrap-v-select" style="text-align: left">
                <label>{{ $t("orders.carrier") }}</label>
                <SelectCarrier v-model="newPart.carrier" :default="true" />
                <div class="md-error" v-if="errors[0]">{{ errors[0] }}</div>
              </div>
            </md-field>
          </ValidationProvider>

          <md-field>
            <label>{{ $t("orders.storageLocation") }}</label>
            <md-input v-model="newPart.storageLocation.fullName" disabled readonly></md-input>
          </md-field>
        </ValidationObserver>
      </template>

      <template slot="footer">
        <md-button class="md-secondary mr-1" @click="hideAddPartModal">{{ $t("orders.cancel") }}</md-button>
        <md-button class="md-success" @click="addPart">{{ $t("orders.save") }}</md-button>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SelectCarrier from "../SelectCarrier/SelectCarrier.vue";
import Modal from "../Modal.vue";

export default {
  components: { ValidationObserver, ValidationProvider, SelectCarrier, Modal },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      parts: [...(this.value || [])],
      addPartModal: false,
      newPart: {
        quantity: null,
        description: "",
        carrier: "",
        weight: null,
        storageLocation: {
          id: null,
          fullName: null,
        },
        storageLocationId: null,
      },
    };
  },
  computed: {
    ...mapState("warehouses", ["storageLocations"]),
  },
  methods: {
    ...mapActions("warehouses", ["getStorageLocations"]),
    async fetchDefaultStorageLocation() {
      if (!this.storageLocations || !this.storageLocations.length) {
        await this.getStorageLocations();
      }
      const defaultLocation = this.storageLocations.find((loc) => loc.id === 544);
      this.newPart.storageLocation = defaultLocation ? { id: defaultLocation.id, fullName: defaultLocation.fullName } : { id: 544, name: "PP-88-88-88" };
      this.newPart.storageLocationId = defaultLocation?.id ?? 544;
    },
    showAddPartModal() {
      this.fetchDefaultStorageLocation();
      this.addPartModal = true;
    },
    hideAddPartModal() {
      this.addPartModal = false;
      this.resetNewPart();
    },
    addPart() {
      this.$refs.addPartForm.validate().then((isValid) => {
        if (!isValid) return;
        this.parts.push({ ...this.newPart, weight: Number(this.newPart.weight) });
        this.$emit("input", this.parts);
        this.hideAddPartModal();
      });
    },
    removePart(index) {
      this.parts.splice(index, 1);
      this.$emit("input", this.parts);
    },
    resetNewPart() {
      this.newPart = {
        quantity: null,
        description: "",
        carrier: "",
        storageLocation: {
          id: null,
          fullName: null,
        },
      };
    },
  },
  watch: {
    value(newValue) {
      this.parts = [...newValue];
    },
  },
  created() {
    this.fetchDefaultStorageLocation();
  },
};
</script>

<style lang="scss" scoped>
.parts-list {
  list-style: none;
  padding: 0;
  display: inline-block;
}
.parts-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  //   margin-bottom: 10px;
  gap: 1rem;
  border-bottom: 1px solid #eee;
  //   padding-bottom: 10px;
  .desc {
    flex: 1 1 auto;
    text-align: left;
  }
}
</style>
